import { Country } from "@libs/enums/country.enum.ts";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import {
  email,
  maxLength,
  phone,
  predicate,
  required
} from "@libs/validation/fieldValidators.ts";
import { ValidationMessages } from "@libs/validation/validation.constants.ts";
import { Validator } from "@libs/validation/Validator.ts";
import { CoreStore } from "@stores/core/CoreStore.ts";

import { LocationDetailsValues } from "./LocationDetails.types.ts";

export class LocationDetailsFormValidator extends Validator<LocationDetailsValues> {
  constructor(core: CoreStore) {
    super();

    const getExistingNamesExcludeCurrent = (id: string) =>
      core.activeLocations.filter(l => l.id !== id).map(x => x.name);

    const requiresCityCondition = (_val: any, address: LocationDetailsValues) =>
      !!core.ref.countries.values.find(
        c => c.code === address?.country && !c.isStateRequired
      );

    const requiresStateCondition = (
      _val: any,
      address: LocationDetailsValues
    ) =>
      !!core.ref.countries.values.find(
        c => c.code === address?.country && c.isStateRequired
      );

    const isNotNewZealandPredicate = () =>
      core.tenantDetails?.country !== Country.NewZealand;

    const isMultiLocationPredicate = () =>
      core.hasPermissions([Permission.PreReleaseMultiLocationAllowed]);

    this.forField("practiceName", [
      required(),
      maxLength(100),
      predicate(
        (_value, values) => !!values?.practiceName,
        (value, values) => {
          return getExistingNamesExcludeCurrent(values.id).includes(value)
            ? ValidationMessages.locationNameAlreadyExists
            : false;
        },
        required()
      )
    ]);
    this.forField("hpiFacilityId", [maxLength(8)]);
    this.forField("city", [maxLength(60)]);
    this.forField("address1", [required(), maxLength(100)]);
    this.forField("address2", [maxLength(100)]);
    this.forField("suburb", [
      predicate(isNotNewZealandPredicate, required()),
      maxLength(60)
    ]);
    this.forField("postCode", [required(), maxLength(10)]);
    this.forField("country", [required()]);
    this.forField("city", predicate(requiresCityCondition, required()));
    this.forField("state", predicate(requiresStateCondition, required()));
    this.forField("phone", [required(), maxLength(50), phone]);
    this.forField("email", [email()]);
    this.forField("timezone", [required()]);

    this.forField("appointmentBookMarker", [
      predicate(isMultiLocationPredicate, required())
    ]);
  }
}
